import React, { useEffect, useRef, useState, memo } from "react";
import "./activityLog.less";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserClock } from "@fortawesome/free-solid-svg-icons/faUserClock";
import UIComponent from "components/UiComponent";
import { useTranslation } from "react-i18next";

const ActivityLog = ({
  className,
  isLoaded,
  htmlContent,
  onClickHandlerCallback,
  isActive = false
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [isTriggered, setisTriggered] = useState(isActive);
  const [isDisplayed, setisDisplayed] = useState(false);

  useEffect(() => {
    onClickHandlerCallback && onClickHandlerCallback(isTriggered);
    setisDisplayed(isTriggered);
  }, [isLoaded, isTriggered]);

  useEffect(() => {
    if (isLoaded && isDisplayed && ref && ref.current) {
      ref.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  }, [isDisplayed]);

  const handleClick = () => {
    setisTriggered((prev) => !prev);
  };

  return (
    <React.Fragment>
      {isLoaded ? (
        <div
          ref={ref}
          className={`activityLog ${className} ${
            isTriggered ? "displayed" : ""
          }`}
        >
          <UIComponent
            id="history"
            component="smart-button"
            class={`activityLogBtn ${isTriggered ? "displayed" : ""}`}
            iconComponent={<FontAwesomeIcon icon={faUserClock} size={"1x"} />}
            onClick={handleClick}
          >
            {t("lbl.HISTORY", "History")}
          </UIComponent>
          {isDisplayed ? (
            <div
              id="historyCnt"
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          ) : null}
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(ActivityLog);
